import { Directive, Input, OnDestroy } from '@angular/core';

import { NavService } from '../../core/nav.service';
import { Lesson } from '../shared/lesson';

@Directive({
  selector: 'app-lesson-edit-nav' // tslint:disable-line:directive-selector
})
export class LessonEditNavDirective implements OnDestroy {
  constructor(private nav: NavService) { }

  ngOnDestroy() {
    this.nav.subActivated = null;
  }

  @Input() set lesson(lesson: Lesson) {
    if (lesson) {
      this.nav.subActivated = [lesson.$key];
      this.nav.updateNavActions();
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-edit/lesson-edit-nav.directive.ts